module.exports = __webpack_public_path__ + "media/images/nav_mark-72a79e9146b0e77775a37137de24e885.svg";